// Import polyfills for Chrome 56 compatibility
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import './bootstrap';

import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();
